import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'
import en from '@/lang/en'
import th from '@/lang/th'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'md'
    },
    lang: {
        locales: { th, en },
        current: 'th'
    },
    theme: {
        themes: {
            light: {
                primary: colors.orange,
                accent: colors.orange
            }
        }
    }
})
